import { generateUuid } from '@lib/uuid';
import { useBlockCreate } from '@nx-frontend/shared/hooks';
import { isPersistantBlockType, PortalBlock } from '@nx-frontend/shared/types';
import { ChangeEventMeta } from '@nx-frontend/shared/types';

interface EnshureGhostBlockProps {
  block: PortalBlock;
  batchId?: string;
  collectId?: string;
  meta?: Omit<Partial<ChangeEventMeta>, 'updatedAt' | 'userId'>;
}

interface EnshureGhostBlockResult {
  block: PortalBlock;
  batchId?: string;
  collectId?: string;
}

export const useEnshureGhostBlock = () => {
  const createBlock = useBlockCreate();

  return async ({
    block,
    collectId,
    batchId = generateUuid(),
  }: EnshureGhostBlockProps): Promise<EnshureGhostBlockResult> => {
    if (block.ghost !== true || !isPersistantBlockType(block)) {
      return { block, batchId, collectId };
    }

    return createBlock({
      block: { ...block, ghost: false },
      collectId,
      batchId,
      openPageAfterCreate: false,
    });
  };
};
